import { CampaignChildStatusType } from 'features/CampaignAndDiscount/@types/campaignUmbrellaChild'
import {
  CampaignUmbrellaChildStatusLabelEnum,
  CampaignUmbrellaChildStatusLabelType,
} from 'features/CampaignAndDiscount/constant/campaignUmbrellaEnum'

export const mapCampaignChildStatusToLabel = (
  status: CampaignChildStatusType | '',
): CampaignUmbrellaChildStatusLabelType | '' => {
  switch (status) {
    case 'Draft Campaign':
      return CampaignUmbrellaChildStatusLabelEnum.DRAFT_CAMPAIGN
    case 'Draft':
      return CampaignUmbrellaChildStatusLabelEnum.DRAFT
    case 'Pending Approval':
      return CampaignUmbrellaChildStatusLabelEnum.PENDING_APPROVAL
    case 'Pending Campaign':
      return CampaignUmbrellaChildStatusLabelEnum.PENDING_CAMPAIGN
    case 'Approved':
      return CampaignUmbrellaChildStatusLabelEnum.APPROVED
    case 'Rejected':
      return CampaignUmbrellaChildStatusLabelEnum.REJECTED
    case 'Closed':
      return CampaignUmbrellaChildStatusLabelEnum.CLOSED
    case 'Cancelled':
      return CampaignUmbrellaChildStatusLabelEnum.CANCELLED
    default:
      return ''
  }
}
